/**
 * User: Keith
 * Author: Faris
 * Date: 6/24/15
 * Time: 10:30 AM
 */

define('app/views/split_mini_slideshow',['require','./page','text!../../../views/split_mini_slideshow.html'],function(require) {

  var Page = require('./page');
  var template = require('text!../../../views/split_mini_slideshow.html');

  return Page.extend({
	 template: _.template(template),
	 
	 events : {
			'click .caretRight' : 'clickNext',
			'swiperight .carets' : 'clickNext',
			'click .caretLeft' : 'clickPrev',
			'swipeleft .carets' : 'clickPrev'
	  },

	  
	  // Init function
	  initialize: function() {
		  this.speed = 7000;
		  this.timer;
		  
		  _.bindAll(this, 'onKeyDown');
		  $(document).bind('keydown', this.onKeyDown);
	  },
	  
	  transitionInComplete: function() {
	      if(this.model.attributes.SLIDES2>1) {
	          this.startTimer();
	      }
	  },
	  
	  transitionOutComplete: function() {
		  clearInterval(this.timer);
		  $(document).unbind('keydown', this.onKeyDown);
		  
		  this.$el.detach();
	      if(this.BGtimer) {
	          clearInterval(this.BGTimer);
	      }
	  },
	  
	  startTimer: function() {
		  this.timer = setInterval(this.nextSlide, this.speed);
	  },
	  
	  nextSlide: function() {
		  $('#miniSlideshow > div:first').fadeOut(1500, function() {
			  $('#miniSlideshow').append($('#miniSlideshow > div:first'));
		  }).next().fadeIn(1500);  
	  },
	  
	  prevSlide: function() {
		  $('#miniSlideshow > div:last').fadeIn(1500, function() {
			  $('#miniSlideshow').prepend($('#miniSlideshow > div:last'));
		  });
		  $('#miniSlideshow > div:first').fadeOut(1500);
	  },
	  
	  clickNext: function() {
		  // Pause, then restart again	  
		  this.pauseAndRestartTimer();
		  this.nextSlide();
	  },
	  
	  clickPrev: function() {		  
		  // Pause, then restart again
		  this.pauseAndRestartTimer();
		  this.prevSlide();
	  },
	  
	  pauseAndRestartTimer: function() {
		  clearInterval(this.timer);		  
		  var thing = this;
		  this.timer = setInterval(function() {
			  thing.nextSlide();
		  }, this.speed*2);
	  },
	  
	  onKeyDown: function(e) {
	    if(this.model.attributes.SLIDES2.length>1) {
    		// Left
    		if(e.which == 37) {
    			this.clickPrev();
    		}
    		// Right
    		if(e.which == 39 ) {
    			this.clickNext();
    		}
	    }
	  },
	  
	  swipe : function() {
		  alert("SWIPED");
	  }
  });
});
